import { ROUTES, facturaPosVerPath } from '../../../config/routes';
import type { Info360ActividadItem, Info360Documento } from './types';

export type Info360DocumentoAccion =
  | { kind: 'ruta'; path: string; label: string }
  | {
    kind: 'pdf';
    url: string;
    titulo: string;
    documentType: 'recibo' | 'devolucion';
    label: string;
  };

type DocumentoConsultable = Pick<Info360Documento, 'tipoCodigo' | 'nroFormulario' | 'numero'>
  | Pick<Info360ActividadItem, 'tipoCodigo' | 'nroFormulario'>;

/** Devuelve cómo consultar el documento, o null si no existe pantalla ni PDF para su tipo. */
export function resolverAccionDocumento(
  documento: DocumentoConsultable,
): Info360DocumentoAccion | null {
  const nroFormulario = documento.nroFormulario;
  if (nroFormulario == null || nroFormulario <= 0) return null;

  switch ((documento.tipoCodigo ?? '').trim()) {
    case '1':
      return {
        kind: 'ruta',
        path: facturaPosVerPath(nroFormulario),
        label: 'Ver factura',
      };
    case '12':
      return {
        kind: 'ruta',
        path: ROUTES.ventas.pedidos.ver(nroFormulario),
        label: 'Ver pedido',
      };
    case '4':
      return {
        kind: 'pdf',
        url: `/api/tesoreria/recibos/${nroFormulario}/pdf`,
        titulo: 'Recibo',
        documentType: 'recibo',
        label: 'Ver recibo',
      };
    case '60':
      return {
        kind: 'pdf',
        url: `/api/DevolucionesVenta/${nroFormulario}/pdf`,
        titulo: 'Devolución',
        documentType: 'devolucion',
        label: 'Ver devolución',
      };
    default:
      return null;
  }
}
